import { Accordion, Icon, Label, Message, Segment } from "semantic-ui-react";
import React from "react";
import ResourceRow from "../ResourceRow";
import styles from "../Resources.module.css"


const DefaultSpiritualResourceSlide1 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="How to Do Oral History"
          url="https://siarchives.si.edu/history/how-do-oral-history"
          descriptionText=""
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Oral Histories from the Library of Congress"
          url="https://loc.gov/folklife/familyfolklife/oralhistory.html"
          descriptionText=""
        />
        <ResourceRow urlText="A Guide for Interviewing Elders"
          url="https://www.senioradvisor.com/blog/2014/09/the-power-of-sharing-life-stories-a-step-by-step-guide-and-resources-for-interviewing-our-elders/"
          descriptionText=""
        />
        <ResourceRow urlText="Capturing the Oral History of Your Family"
          url="https://nmaahc.si.edu/explore/stories/capturing-your-familys-oral-history"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultSpiritualResourceSlide2 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="The 5 Basic Steps of Funeral Planning"
          url="https://www.funeralbasics.org/5-basic-steps-funeral-planning/"
          descriptionText=""
        />
        <ResourceRow urlText="National Institute on Aging Guidance"
          url="https://www.nia.nih.gov/health/what-do-after-someone-dies"
          descriptionText=""
        />
        <ResourceRow urlText="Shopping for Funeral Services"
          url="https://consumer.ftc.gov/articles/shopping-funeral-services"
          descriptionText=""
        />
        <ResourceRow urlText="Prince of Peace Catholic Funeral Planning"
          url="https://www.popcatholic.org/funeral-planning"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultSpiritualResourceSlide3 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Helping Discuss End-of-Life Care"
          url="https://theconversationproject.org/"
          descriptionText=""
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="What is Hospice Care?"
          url="https://hospicefoundation.org/Hospice-Care/Hospice-Services"
          descriptionText=""
        />
        <ResourceRow urlText="Hospice Care"
          url="https://www.merckmanuals.com/home/fundamentals/death-and-dying/hospice-care"
          descriptionText=""
        />
        <ResourceRow urlText="National Institute on Aging Guidance on Comfort Care"
          url="https://www.nia.nih.gov/health/providing-comfort-end-life"
          descriptionText=""
        />
        <ResourceRow urlText="Treatment Options at End of Life"
          url="https://www.merckmanuals.com/home/fundamentals/death-and-dying/treatment-options-at-the-end-of-life"
          descriptionText=""
        />
        <ResourceRow urlText="Choices to Be Made at End of Life"
          url="https://www.merckmanuals.com/home/fundamentals/death-and-dying/choices-to-make-before-death"
          descriptionText=""
        />
        <ResourceRow urlText="NIH End-of-Life Links"
          url="https://www.nia.nih.gov/health/end-life"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultSpiritualResourceSlide4 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Spirituality Practices"
          url="http://www.spiritualityandpractice.com/practices/practices.php?id=9"
          descriptionText=""
          groupedHeaderText=""
        />
        <ResourceRow urlText="Mayo Clinic: Forgiveness"
          url="http://www.mayoclinic.com/health/forgiveness/MH00131"
          descriptionText=""
        />
        <ResourceRow urlText="Aging Parent/Adult Child Relationships"
          url="https://www.caregivercalifornia.org/2022/04/06/from-child-to-caregiver-how-to-manage-your-changing-relationship-with-an-elderly-parent/"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultSpiritualResourceSlide5 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="The Spiritual Dimensions of Conscious Aging"
          url="http://www.spiritualityandpractice.com/books/features.php?id=10905"
        />
        <ResourceRow urlText="The Gift of Years: Growing Older Gracefully"
          url="http://www.spiritualityandpractice.com/books/excerpts.php?id=18093"
        />
      </Segment.Group>
    </>
  );
}

const DefaultSpiritualResourceSlide6 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="What is Faith-Based Senior Living?"
          url="https://www.seniorly.com/resource-center/health-and-lifestyle/what-is-faith-based-senior-living"
          descriptionText=""
        />
        <ResourceRow urlText="About Methodist Homes"
          url="https://www.methodisthomes.org/about-us"
          descriptionText=""
        />
        <ResourceRow urlText="Respite for All"
          url="https://www.respiteforall.org/"
          descriptionText=""
          groupedHeaderText=""
        />

        <ResourceRow urlText="Senior Living: Faith"
          url="https://www.seniorliving.org/care/faith/"
          descriptionText=""
        />
        <ResourceRow urlText="Senior Living Ministries: About"
          url="https://www.seniorlivingministries.org/about/"
          descriptionText=""
        />
        <ResourceRow urlText="Spiritual Care & Support for the Elderly"
          url="https://www.focusonthefamily.com/family-qa/spiritual-care-and-support-for-the-elderly/"
          descriptionText=""
        />
        <ResourceRow urlText="Older Adult Ministry Ideas"
          url="https://www.umcdiscipleship.org/resources/48-older-adult-ministry-ideas"
          descriptionText=""
        />
        <ResourceRow urlText="Connect Program, Tuscaloosa AL"
          url="https://connectforjoy.org"
          descriptionText=""
        />
        <ResourceRow urlText="Founders Place, Birmingham AL"
          url="https://saint-lukes.com/ministries/founders-place/"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
}

const DefaultSpiritualResourceSlide7 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Osher Lifelong Learning Institutes"
          url="https://www.osherfoundation.org/olli.html"
          descriptionText=""
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Ways to Find Your Purpose"
          url="https://www.psychologytoday.com/us/blog/changepower/202002/9-ways-find-your-purpose-you-age"
          descriptionText=""
          groupedHeaderText="Finding Purpose and Meaning"
        />
        <ResourceRow urlText="About a Strong Sense of Purpose"
          url="https://emoha.com/blogs/give-back/finding-meaning-and-purpose-old-age#:~:text=A%20strong%20sense%20of%20purpose,how%20fast%20someone%20is%20aging"
          descriptionText=""
        />
        <ResourceRow urlText="Positive Psychology: Benefits of Journaling"
          url="https://positivepsychology.com/benefits-of-journaling/"
          descriptionText=""
          groupedHeaderText="Benefits of Journaling"
        />
        <ResourceRow urlText="Why Everyone Should Keep a Journal"
          url="https://healthy.kaiserpermanente.org/health-wellness/healtharticle.7-benefits-of-keeping-a-journal"
          descriptionText=""
        />
        <ResourceRow urlText="Evidence-Based Benefits of Journaling"
          url="https://www.reflection.app/blog/benefits-of-journaling"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
}

const DefaultSpiritualResourceSlide8 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Healing Prayers"
          url="https://connectusfund.org/25-healing-prayers-for-the-sick-dying-and-elderly"
          descriptionText=""
          groupedHeaderText="Prayers For and About Older Adults"
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Collection of Prayers"
          url="https://www.hfny.org/blog/prayers-elderly#:~:text=Father%2C%20we%20pray%20that%20You,life%20has%20become%20a%20struggle"
          descriptionText=""
        />
        <ResourceRow urlText="Prayer of the Elderly"
          url="https://www.usccb.org/prayers/prayer-elderly-pope-saint-john-paul-ii"
          descriptionText=""
        />
        <ResourceRow urlText="Prayers for Aging"
          url="https://www.xavier.edu/jesuitresource/online-resources/prayer-index/prayers-for-aging"
          descriptionText=""
        />
        <ResourceRow urlText="A Prayer for Those Caring for an Aging Parent"
          url="https://ritualwell.org/ritual/burden-and-blessings-prayer-those-caring-aging-parent/"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
}

// const DefaultSpiritualResourceSlide9 = () => {
//   return (
//     <>
//       <ResourceRow urlText=""
//         url=""
//         descriptionText=""
//         /> 
//       <ResourceRow urlText=""
//         url=""
//         descriptionText=""
//         />    
//       <ResourceRow urlText=""
//         url=""
//         descriptionText=""
//         />
//       <ResourceRow urlText=""
//         url=""
//         descriptionText=""
//         />
//       <ResourceRow urlText=""
//         url=""
//         descriptionText=""
//         />    
//       <ResourceRow urlText=""
//         url=""
//         descriptionText=""
//         />
//     </>
//   );
// }

const accordionResourceDisplay = (keyVal: string, title: string, slideFunction: any) => {

  const accordions = [
    {
      key: 'keyVal',
      index: 0,
      title: {
        icon: <Icon name='dropdown' className={styles.resourcesAccordionLabelTitleIcon} />,
        content: <Label className={styles.resourcesAccordionLabelTitle} > {title} </Label>
      },
      content: {
        content: (<Message className={styles.resourcesAccordionMessageBox} content={slideFunction()} />)
      }
    }
  ];

  return (
    <>
      <div className={styles.resourceAccordionWrapper}>
        <Accordion panels={accordions} defaultActiveIndex={0} />
      </div>
    </>
  );
}

const AllResources = () => {
  return (
    <>
      {accordionResourceDisplay('SpiritualDomainTask1', 'Storytelling Resources', () => DefaultSpiritualResourceSlide1(""))}
      {accordionResourceDisplay('SpiritualDomainTask2', 'Funeral Wishes Resources', () => DefaultSpiritualResourceSlide2(""))}
      {accordionResourceDisplay('SpiritualDomainTask3', 'End of Life Care Resources', () => DefaultSpiritualResourceSlide3(""))}
      {accordionResourceDisplay('SpiritualDomainTask4', 'Making Peace Resources', () => DefaultSpiritualResourceSlide4(""))}
      {accordionResourceDisplay('SpiritualDomainTask5', 'Spiritual Beliefs and Needs Resources', () => DefaultSpiritualResourceSlide5(""))}
      {accordionResourceDisplay('SpiritualDomainTask6', 'Faith-Based Programs Resources', () => DefaultSpiritualResourceSlide6(""))}
      {accordionResourceDisplay('SpiritualDomainTask7', 'Discovering Purpose Resources', () => DefaultSpiritualResourceSlide7(""))}
      {accordionResourceDisplay('SpiritualDomainTask8', 'Prayer with Parents Resources', () => DefaultSpiritualResourceSlide8(""))}
    </>
  );
};

const SpiritualResourceFactory: React.FC<{
  questionKey: string;
}> = (props) => {
  const { questionKey } = props;

  switch (questionKey) {
    case "SpiritualDomainTask1":
      return DefaultSpiritualResourceSlide1('Storytelling');
    case "SpiritualDomainTask2":
      return DefaultSpiritualResourceSlide2('Funeral Wishes');
    case "SpiritualDomainTask3":
      return DefaultSpiritualResourceSlide3('End of Life Care');
    case "SpiritualDomainTask4":
      return DefaultSpiritualResourceSlide4('Making Peace');
    case "SpiritualDomainTask5":
      return DefaultSpiritualResourceSlide5('Spiritual Beliefs and Needs');
    case "SpiritualDomainTask6":
      return DefaultSpiritualResourceSlide6('Faith-Based Programs');
    case "SpiritualDomainTask7":
      return DefaultSpiritualResourceSlide7('Discovering Purpose');
    case "SpiritualDomainTask8":
      return DefaultSpiritualResourceSlide8('Prayer with Parents');
    case "SpiritualDomainTask9":
    case "":
      return AllResources();
    default:
      return null;
  }
};

export default SpiritualResourceFactory;
